import $ from 'jquery'
import Bubble from '../components/bubble';
import Video from '../components/video';
import Audio from '../components/audio';
import Card from '../components/card';
import ChessBoard from '../components/chessBoard';
import Activity from '../components/activity';
import DirectionBox from '../components/directionBox';
import Options from '../components/options';
import Table from '../components/table';

export default class Screen {
  constructor() {
    this.bubble = new Bubble();
    this.card = new Card();
    this.video = new Video();
    this.audio = new Audio();
    this.chessBoard = new ChessBoard();
    this.activity = new Activity();
    this.directionBox = new DirectionBox();
    this.options = new Options();
    this.table = new Table();
  }

  static preLoadedLessons = [];

  static loadPreloadedLessonsArray() {
    for (let i = 0; i < 20; i++) {
      Screen.preLoadedLessons[i] = false;
    }
  }

  static updatePreloadedLessonsArray(index, value, imageArray = []) {
    if (Screen.preLoadedLessons[index] !== value) {
      Screen.preLoadedLessons[index] = value;

      let imageUrls = '';

      for (let i = 0; i < imageArray.length; i++) {
        imageUrls = imageUrls + 'url(' + imageArray[i] + ')';
      }
      
      $('<style>body:before{content: ' + imageUrls + '}</style>').appendTo('head');
    }
  }

  /**
  * @name renderLesson
  * @function
  * @param {lessonConfig}
  * @description: render the chapter based on the current lesson
  */
  renderLesson(lessonConfig) {
    if (lessonConfig) {
      if (lessonConfig.text) {
        $(document).trigger('bubble-show', lessonConfig.text);
      } if (lessonConfig.video) {
        $(document).trigger('video-show', lessonConfig);
      } if (lessonConfig.audio) {
        $(document).trigger('audio-play', lessonConfig.audio);
      } if (lessonConfig.qa) {
        $(document).trigger('qa-bubble-show', lessonConfig);
      } if (lessonConfig.chessboard) {
        $(document).trigger('chessBoard-show', lessonConfig.chessboard);
      } if (lessonConfig.activity) {
        $(document).trigger('activity-show', lessonConfig.activity);
      } if (lessonConfig.directions) {
        $(document).trigger('direction-box-show', lessonConfig.directions);
      } if (lessonConfig.options) {
        $(document).trigger('options-show', lessonConfig.options);
      } if (lessonConfig.table) {
        $(document).trigger('table-show');
      }
    }
  }
} 


// WEBPACK FOOTER //
// ./src/classes/screen.js